// extracted by mini-css-extract-plugin
module.exports = {"root":"FlexRow_root__jLDv9","wrapper":"FlexRow_wrapper__UhwFA"};